import React from 'react'
import PropTypes from 'prop-types'
import {Table, TableBody, TableCell, TableHead, TableRow, Typography, withStyles} from "@material-ui/core";
import Tr from "translations/Translations";
import TextInput from "components/TextInput";
import INPUT_TYPE from "constants/INPUT_TYPE";
import Form from "components/Form";
import VS from "constants/ValidationShema";
import moment from "libs/moment";
import DateFormats from "constants/DateFormats";
import BoldTypography from "components/BoldTypography";

const style = theme => ({
    root: {},
    limit: {
        color: theme.palette.text.secondary,
    },
    relative: {
        position: 'relative'
    },
    noBorder: {
        border: 'none'
    },
    headerDealings: {
        width: '20%',
        border: 'none'
    },
    headerValue: {
        width: '40%',
        border: 'none'
    },
    inputValue: {
        width: '80%'
    }
})

function RealizationAmountForm(
    {
        formId,
        realizationValues,
        required,
        editable,
        onSubmit,
        classes
    }) {

    const optionExists = realizationValues.dealings.some(x => x.showRealizationGrossOptionValue);

    const getInitValues = () => {
        const init = {
            dealings: realizationValues.dealings.map(({realizationGrossValue, realizationGrossOptionValue, showRealizationGrossOptionValue, identity}) => ({
                realizationGrossValue,
                realizationGrossOptionValue,
                showRealizationGrossOptionValue,
                identity
            }))
        };
        return init;
    }

    const getValidationSchema = () => {
        const shape = {
            realizationGrossValue: required ? VS.amount(0, true) : VS.amountOptional(0, true),
            realizationGrossOptionValue: VS.any().when("showRealizationGrossOptionValue", {
                is: showRealizationGrossOptionValue => required && showRealizationGrossOptionValue,
                then: VS.amount(0, true),
                otherwise: VS.amountOptional(0, true)
            })
        }

        return VS.object({
            dealings: VS.lazy(x => {
                return VS.arrayOfShape(shape)
            })
        })
    }

    const formatPublishDate = (publishDate) => {
        return moment(publishDate).format(DateFormats.DATETIME_WITH_SECONDS_FORMAT);
    }

    return (<Form
        id={formId}
        initialValues={getInitValues()}
        validationSchema={getValidationSchema()}
        onSubmit={onSubmit}
    >
        {(formikProps) => (
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell className={classes.headerDealings}>
                            <BoldTypography>{Tr("dealing_list")}</BoldTypography>
                        </TableCell>
                        <TableCell className={classes.headerValue}>
                            <BoldTypography className={classes.inputValue}>{Tr("realization_value")}</BoldTypography>
                        </TableCell>
                        <TableCell className={classes.headerValue}>
                            {optionExists && <BoldTypography className={classes.inputValue}>{Tr("realization_option_value")}</BoldTypography>}
                        </TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {realizationValues.dealings.map((x, i) =>
                        (<TableRow key={`d${x.identity}`}>
                            <TableCell className={classes.noBorder}>
                                <BoldTypography>{`${Tr("part_nr")} ${i + 1}`}</BoldTypography>
                                {x.realizationPublishDate && <Typography key={x.identity} variant='caption' className={classes.limit}>{Tr('realization_publish_date')}: {formatPublishDate(x.realizationPublishDate)}</Typography>}
                            </TableCell>
                            <TableCell className={classes.noBorder}>
                                <>
                                    <TextInput
                                        key={`d${x.identity}`}
                                        id={`dealings.${i}.realizationGrossValue`}
                                        label={''}
                                        formikProps={formikProps}
                                        type={INPUT_TYPE.NUMBER_19}
                                        disabled={!editable}
                                        required={required}
                                        className={classes.inputValue}
                                    />
                                </>
                            </TableCell>
                            <TableCell className={classes.noBorder}>
                                {x.showRealizationGrossOptionValue && <>
                                     <TextInput
                                        key={`d${x.identity}`}
                                        id={`dealings.${i}.realizationGrossOptionValue`}
                                        label={''}
                                        formikProps={formikProps}
                                        type={INPUT_TYPE.NUMBER_19}
                                        disabled={!editable}
                                        required={required}
                                        className={classes.inputValue}
                                        alertText={x.publishRealizationGrossOptionValue === true ? Tr('realization_option_value_published') : (x.publishRealizationGrossOptionValue === false ? Tr('realization_option_value_not_published') : undefined)}
                                    />
                                </>}
                            </TableCell>
                        </TableRow>))
                    }
                </TableBody>
            </Table>
            )}
    </Form>)
}

RealizationAmountForm.propTypes = {
    formId: PropTypes.string.isRequired,
    realizationValues: PropTypes.shape({
        dealings: PropTypes.array.isRequired,
        realizationValuePublished: PropTypes.bool
    }).isRequired,
    required: PropTypes.bool.isRequired,
    editable: PropTypes.bool.isRequired,
    onSubmit: PropTypes.func.isRequired,
}

export default withStyles(style)(RealizationAmountForm);